import { HttpHandlerFn, HttpRequest } from '@angular/common/http';

export function environmentInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  // Skip interceptor completely for assets requests
  if (req.url.includes('/assets/')) {
    return next(req);
  }

  const dataRequest = !(
    req.url.startsWith('logs/') || req.url.startsWith('auth/permissions')
  );
  const reqUrl = dataRequest ? `data/${req.url}` : req.url;
  const url = `${window.location.origin}/api/${reqUrl}`;
  const newReq = req.clone({ url });
  return next(newReq);
}
